import { useCallback, useState } from "react";
import { TTipoDocReceber } from "../../../../../types/api/financeiro/tipos-doc-receber";
import DialogCriacaoEditTiposDocumentos from "./DialogCriacaoEditTiposDocumentos";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function TiposDocumento() {

    const [openModal, setOpenModal] = useState<TOpenModalTiposDocumento>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | string, value?: TTipoDocReceber | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<TTipoDocReceber>
                titulo="Tipos de documentos"
                endpoints={{
                    listar: "financeiro/contas-receber/pesquisar-tipos-documento",
                    deletar: "financeiro/configuracoes/excluir-tipo-documento",
                }}
                colunas={colunas}
                queryKey="pesquisar-tipos-documento"
                onEditar={(situacao) => {
                    handleModalAction("open", situacao.id, situacao)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Tipo de documento deletado com sucesso!"
                mensagemErroDeletar="Erro ao deletar tipo de documento!"
                mensagemSemDados="Nenhum tipo de documento encontrado."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditTiposDocumentos
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export type TOpenModalTiposDocumento = {
    open: string | boolean | null;
    defaultValue: TTipoDocReceber | null;
} | null

const colunas: ConfiguracaoColunas<TTipoDocReceber>[] = [
    {
        campo: "id",
        titulo: "Código",
    },
    {
        campo: "nome",
        titulo: "nome",
    },
];
